import React from 'react';

const Product = ({
  item: {
    name, comment, sku, quantity, price,
  },
}) => (
  <tr>
    <td>
      {name}
      {comment.length !== 0 && (
      <span className="comment">
        <br />
        {`Observação: ${comment}`}
      </span>
      )}
    </td>
    <td>{sku}</td>
    <td>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price)}</td>
    <td>{quantity}</td>
    <td>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price * quantity)}</td>
  </tr>
);

export default Product;
